import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTermsAndConditionWidgetStyles = () => {
  return StyleSheet.create({
    bottomMargin: {
      marginBottom: tokens.spacing.SPACING_4
    },
    topMargin: {
      marginTop: tokens.spacing.SPACING_12
    },
    avatar: {
      alignSelf: 'center',
      marginBottom: tokens.spacing.SPACING_16
    },
    tncTitle: {
      marginTop: tokens.spacing.SPACING_16
    },
    listTopSpace: {
      marginTop: tokens.spacing.SPACING_12
    },
    ctaStyles: {
      marginTop: tokens === null || tokens === void 0 ? void 0 : tokens.spacing.SPACING_8,
      alignSelf: 'center'
    }
  });
};